<script lang="ts">
	import type { MeetingMinute } from '$lib/types/meeting';
	import { formatDate, formatMeetingTime } from '$lib/utils';

	export let meeting: MeetingMinute;
	export let showYear = false;

	$: meetingTimeStr = formatMeetingTime(meeting.startTime, meeting.endTime, meeting.timezone);
</script>

<article
	class="rounded-lg border border-gray-200 bg-gray-50 p-6 shadow-md transition-shadow hover:shadow-lg dark:border-gray-700 dark:bg-gray-900 dark:shadow-xl dark:hover:shadow-2xl"
>
	<div class="mb-3 flex items-start justify-between">
		<div class="flex-1">
			<h3 class="mb-2 text-xl font-semibold text-gray-900 dark:text-white">
				<a
					href={meeting.slug}
					class="transition-colors hover:text-blue-600 dark:hover:text-blue-400"
				>
					{meeting.title}
				</a>
			</h3>
			<div class="flex flex-wrap gap-3 text-sm text-gray-600 dark:text-gray-300">
				<time datetime={meeting.date.toISOString()}>
					{formatDate(meeting.date)}
					{#if showYear}
						({meeting.date.getFullYear()})
					{/if}
					{#if meetingTimeStr}
						• {meetingTimeStr}
					{/if}
				</time>
				<span
					class="rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-800 dark:bg-blue-900/30 dark:text-blue-300"
				>
					{meeting.type}
				</span>
				{#if meeting.status}
					{#if meeting.status === 'Approved'}
						<span
							class="rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800 dark:bg-green-900/30 dark:text-green-300"
						>
							{meeting.status}
						</span>
					{:else if meeting.status === 'Pending Approval'}
						<span
							class="rounded-full bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300"
						>
							{meeting.status}
						</span>
					{:else}
						<span
							class="rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-800 dark:bg-gray-700 dark:text-gray-300"
						>
							{meeting.status}
						</span>
					{/if}
				{/if}
			</div>
		</div>
	</div>

	{#if meeting.summary}
		<p class="leading-relaxed text-gray-700 dark:text-gray-300">
			{meeting.summary}
		</p>
	{/if}
</article>
